export default "__VITE_ASSET__5jzuXfTg__"